// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"HomepageBody_boxesContainer__3INCg","homeText":"HomepageBody_homeText__eMm-z"};